import React from 'react';
import classNames from 'classnames';
import { useIntl } from '../../../../util/reactIntl';
import feature1En from '../../../../assets/images/merchant-lp-point-1-en.png';
import feature1Ar from '../../../../assets/images/merchant-lp-point-1-ar.png';
import feature2En from '../../../../assets/images/merchant-lp-point-2-en.png';
import feature2Ar from '../../../../assets/images/merchant-lp-point-2-ar.png';
import feature3En from '../../../../assets/images/merchant-lp-point-3-en.png';
import feature3Ar from '../../../../assets/images/merchant-lp-point-3-ar.png';
import {
  BarChart3Icon,
  CalendarIcon,
  CheckCircle2Icon,
  TagIcon,
} from '../MerchantIcons';
import css from './AppFeatures.module.css';

const AppFeatures = () => {
  const intl = useIntl();
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  const calendarItems = [
    'ForBusiness.feature2Item1',
    'ForBusiness.feature2Item2',
    'ForBusiness.feature2Item3',
  ];
  const insightsItems = [
    'ForBusiness.feature3Item1',
    'ForBusiness.feature3Item2',
    'ForBusiness.feature3Item3',
  ];

  return (
    <section className={classNames(css.section, arabicLanguage && css.arabicDirection)}>
      <div className={css.inner}>
        <div className={css.header}>
          <h2 className={css.title}>
            {intl.formatMessage({ id: 'ForBusiness.appFeaturesTitle' })}{' '}
            <span className={css.titleSoft}>
              {intl.formatMessage({ id: 'ForBusiness.appFeaturesTitleSoft' })}
            </span>
          </h2>
          <p className={css.subtitle}>
            {intl.formatMessage({ id: 'ForBusiness.appFeaturesSub' })}
          </p>
        </div>

        {/* Feature 1 — Post deals */}
        <div className={classNames(css.row, css.rowImageLarge)}>
          <div className={classNames(css.textCol, css.textColSecondOnMobile)}>
            <span className={classNames(css.iconTile, css.iconTilePrimary)} aria-hidden="true">
              <TagIcon className={css.iconSvg} />
            </span>
            <h3 className={css.featureTitle}>
              {intl.formatMessage({ id: 'ForBusiness.feature1Title' })}
            </h3>
            <p className={css.featureText}>
              {intl.formatMessage({ id: 'ForBusiness.feature1Description' })}
            </p>
          </div>
          <div className={classNames(css.mediaCol, css.mediaColFirstOnMobile, css.mediaColAlignEnd)}>
            <div className={css.imageBare}>
              <img
                src={arabicLanguage ? feature1Ar : feature1En}
                alt={intl.formatMessage({ id: 'ForBusiness.feature1ImageAlt' })}
                className={css.featureImage}
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Feature 2 — Smart calendar (image left on desktop) */}
        <div className={classNames(css.row, css.rowImageLargeLeft)}>
          <div className={classNames(css.mediaCol, css.mediaColFirstOnDesktop, css.mediaColAlignStart)}>
            <div className={css.imageBare}>
              <img
                src={arabicLanguage ? feature2Ar : feature2En}
                alt={intl.formatMessage({ id: 'ForBusiness.feature2ImageAlt' })}
                className={css.featureImage}
                loading="lazy"
              />
            </div>
          </div>
          <div className={classNames(css.textCol, css.textColSecondOnDesktop)}>
            <span className={classNames(css.iconTile, css.iconTileDark)} aria-hidden="true">
              <CalendarIcon className={css.iconSvg} />
            </span>
            <h3 className={css.featureTitle}>
              {intl.formatMessage({ id: 'ForBusiness.feature2Title' })}
            </h3>
            <p className={css.featureText}>
              {intl.formatMessage({ id: 'ForBusiness.feature2Description' })}
            </p>
            <ul className={css.checkList}>
              {calendarItems.map(id => (
                <li key={id} className={css.checkItem}>
                  <CheckCircle2Icon className={css.checkIcon} />
                  {intl.formatMessage({ id })}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Feature 3 — Insights */}
        <div className={classNames(css.row, css.rowImageLarge)}>
          <div className={classNames(css.textCol, css.textColSecondOnMobile)}>
            <span className={classNames(css.iconTile, css.iconTileAccent)} aria-hidden="true">
              <BarChart3Icon className={css.iconSvg} />
            </span>
            <h3 className={css.featureTitle}>
              {intl.formatMessage({ id: 'ForBusiness.feature3Title' })}
            </h3>
            <p className={css.featureText}>
              {intl.formatMessage({ id: 'ForBusiness.feature3Description' })}
            </p>
            <ul className={css.checkList}>
              {insightsItems.map(id => (
                <li key={id} className={css.checkItem}>
                  <CheckCircle2Icon className={css.checkIcon} />
                  {intl.formatMessage({ id })}
                </li>
              ))}
            </ul>
          </div>
          <div className={classNames(css.mediaCol, css.mediaColFirstOnMobile, css.mediaColAlignEnd)}>
            <div className={css.imageBare}>
              <img
                src={arabicLanguage ? feature3Ar : feature3En}
                alt={intl.formatMessage({ id: 'ForBusiness.feature3ImageAlt' })}
                className={css.featureImage}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppFeatures;
